var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.833,
    height: 25.216,
    fill: "#333",
    rx: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M13.735 11.97l-4.233 1.878a2.613 2.613 0 0 1-.01-.228c0-1.378 1.085-2.495 2.424-2.495a2.39 2.39 0 0 1 1.819.846zm-1.819-2.71c1.998 0 3.672 1.422 4.12 3.336l-1.708.768v-.003l-1.748.79-4.192 1.886a4.43 4.43 0 0 1-.71-2.417c0-2.408 1.898-4.36 4.238-4.36zM15.2 16.927c-1.558 1.458-3.62 1.601-5.432.517l1.023-1.534c1.031.607 2.067.509 3.108-.297l1.301 1.314M16.464 15.682l-.01-8.117h1.507v7.898c0 .076.01.142.107.181l1.31.52-.59 1.568-1.536-.664c-.582-.251-.787-.615-.788-1.386"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2191C3",
    d: "M22.304 15.62a2.532 2.532 0 0 1-.191-3.845l-1.031-1.669a4.468 4.468 0 0 0 .248 7.202l.974-1.688"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAEC32",
    d: "M23.103 11.234c.26-.092.54-.142.833-.142 1.054 0 1.954.647 2.305 1.556l1.913-.156c-.462-1.855-2.174-3.233-4.218-3.233-.577 0-1.128.111-1.632.31l.799 1.665"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0362B",
    d: "M26.36 13.919c-.059 1.309-1.088 2.351-2.348 2.351-.198 0-.39-.026-.573-.074l-.717 1.743c.406.14.84.216 1.29.216 2.233 0 4.053-1.854 4.142-4.177l-1.793-.059"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElo);
export default __webpack_public_path__ + "static/media/elo.2e7893a6cfe65f84aa2892a79204d00c.svg";
export { ForwardRef as ReactComponent };